import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=718842c0&"
import script from "./Scan.vue?vue&type=script&lang=js&"
export * from "./Scan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports